import OrgapiClient from "@/services/OrgapiClient";
export default {
  //   //get and set session id VUE_APP_APP_ID
  /**
   * get session id api
   * @param {*} admin
   */
  getSessionId(admin) {
    return OrgapiClient.get("/session/getsession/" + admin + "/" + process.env.VUE_APP_APP_ID);
  },
  postRoute(data) {
    return OrgapiClient.post("/session/getroute/", data);
  },
  getSwitchOrg(data) {
    return OrgapiClient.post("/session/getswitchorg/", data);
  },
};
